import instance from '../axios'

const featuredApi = {
    getFeatured: (count: number = 20) => {
        return instance.get(`/featured`, { params: { count } })
    }
}

export default featuredApi